import { render, staticRenderFns } from "./SendData.vue?vue&type=template&id=b93b8d98&"
import script from "./SendData.vue?vue&type=script&lang=js&"
export * from "./SendData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports